export default {
  title: 'We are sorry...',
  description: 'Your current session has expired due to inactivity.',
  goBack: 'Please go back to the Home Page to start the process once again.',
  startOver: 'Start over',
  titleNoReturn: 'Your link has expired',
  descriptionNoReturn: 'We’ll need to re-send a new link.',
};
